
export const BASE_URL = process.env.RAZZLE_BASE_URL
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
export const TRANSLATE_DEFAULT_LANGUAGE = process.env.RAZZLE_TRANSLATE_DEFAULT_LANGUAGE || 'fr'
// we parse the other languages because we use it as array in the env
export const TRANSLATE_LANGUAGES = JSON.parse(process.env.RAZZLE_TRANSLATE_LANGUAGES || '[]')


export const GOOGLE_TRANSLATE_API_KEY = process.env.RAZZLE_GOOGLE_TRANSLATE_API_KEY



export const TRANSLATION_AUTH_TOKEN = process.env.RAZZLE_TRANSLATION_AUTH_TOKEN


export const LOCAL_BASE_URL = `http://${process.env.HOST}:${process.env.PORT}/`


export const STATIC_PATH = `${process.env.PUBLIC_PATH}${ process.env.NODE_ENV === 'development' ? 'static/' : '_razzle/static/' }`
